import { Store } from "@tanstack/react-store";

interface ISoundStore {
  isMuted: boolean;
}

const initialState: ISoundStore = {
  isMuted: false,
};

const soundStore = new Store(initialState);

const setIsMuted = (isMuted: boolean) => {
  soundStore.setState((state) => ({
    ...state,
    isMuted,
  }));
};

export { soundStore, setIsMuted };
